import { attributes } from "@type-r/models";
import { Address } from "./address";

export type CommonParticipant = InstanceType<typeof CommonParticipant>;
export const CommonParticipant = attributes({
    id: Number,
    externalId: String,
    companyId: Number,
    name: String,
    duns: String,
    countryName: String,
    platformCode: String,
    address: Address
});